<svg xmlns="http://www.w3.org/2000/svg" width="19" height="4" viewBox="0 0 19 4" fill="none">
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 2C7.5 0.8954 8.3954 0 9.5 0C10.6046 0 11.5 0.8954 11.5 2C11.5 3.1046 10.6046 4 9.5 4C8.3954 4 7.5 3.1046 7.5 2Z"
        fill="#00FF98"
    />
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5 2C14.5 0.8954 15.3954 0 16.5 0C17.6046 0 18.5 0.8954 18.5 2C18.5 3.1046 17.6046 4 16.5 4C15.3954 4 14.5 3.1046 14.5 2Z"
        fill="#00FF98"
    />
    <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 2C0.5 0.8954 1.39543 0 2.5 0C3.60457 0 4.5 0.8954 4.5 2C4.5 3.1046 3.60457 4 2.5 4C1.39543 4 0.5 3.1046 0.5 2Z"
        fill="#00FF98"
    />
</svg>;

import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const dotsHorizontalTestId = 'dots-horizontal-test-id';

export const DotsHorizontalIcon = ({ fill = 'black', size = 'xsmall' }: IconProps) => {
    const iconSize = IconSizes[size];
    const fillStyle = cn(Styles[fill], Styles.fill);

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={iconSize}
            height={iconSize}
            viewBox="0 0 19 4"
            fill="none"
            data-testid={dotsHorizontalTestId}
        >
            <g className={fillStyle}>
                <path d="M7.5 2C7.5 0.8954 8.3954 0 9.5 0C10.6046 0 11.5 0.8954 11.5 2C11.5 3.1046 10.6046 4 9.5 4C8.3954 4 7.5 3.1046 7.5 2Z" />
                <path d="M14.5 2C14.5 0.8954 15.3954 0 16.5 0C17.6046 0 18.5 0.8954 18.5 2C18.5 3.1046 17.6046 4 16.5 4C15.3954 4 14.5 3.1046 14.5 2Z" />
                <path d="M0.5 2C0.5 0.8954 1.39543 0 2.5 0C3.60457 0 4.5 0.8954 4.5 2C4.5 3.1046 3.60457 4 2.5 4C1.39543 4 0.5 3.1046 0.5 2Z" />
            </g>
        </svg>
    );
};

DotsHorizontalIcon.TEST_ID = dotsHorizontalTestId;
